<template>
  <article class="example-page">
    <h1>List</h1>
    <list
      :order-by="orderBy"
      :list-items="listItemsData"
      :name-label="nameLabel"
      :assets-label="assetsLabel"
      :date-label="dateLabel"
      @optionSelected="optionSelected"
    >
      <header slot="header-labels" class="header-labels">
        <span>Name</span>
        <span v-if="!isSortedByInvitedAt">Assets</span>
        <span v-else>Date Invited</span>
      </header>
      <li slot="listItem" slot-scope="props">
        <a>
          <span>{{ props.value.name }}</span><span v-if="!isSortedByInvitedAt" span>{{ props.value.assets | formatCurrency }}</span>
          <span v-else>{{ props.value.invitedAt | formatDate }}</span>
        </a>
      </li>
    </list>
  </article>
</template>

<script>
import '@/lib/icons/email';
import '@/lib/icons/list';
import moment from 'moment';
import filters from '@/lib/utils/filters';

import { list } from '@/components/layout';


function isPending(item) {
  return !item.joinedAt;
}

export default {
  filters,
  head: {
    title: 'List Component',
  },
  components: { list },

  data() {
    return {
      title: 'List Component',
      nameLabel: 'Name',
      assetsLabel: 'Assets',
      dateLabel: 'Date Invited',
      selectedSortOption: 'name',
      orderBy: [
        {
          orderLabel: ' Sort by', label: 'First Name', sortBy: 'name', asc: true,
        },
        {
          orderLabel: ' Sort by', label: 'Assets', sortBy: 'assets', asc: false,
        },
        {
          orderLabel: ' Filter by', label: 'Pending Invitations', sortBy: 'invitedAt', asc: true, filter: isPending,
        },
      ],
      listItemsData: [
        {
          name: 'Andrew',
          assets: 4,
          invitedAt: moment('2015-08-15T21:06:40.099Z'),
        },
        {
          name: 'Hawthorne',
          assets: 43,
          invitedAt: moment('2016-08-11T21:06:40.099Z'),
        },
        {
          name: 'Aaron',
          assets: 1400.456,
          joinedAt: moment('2001-02-12T21:06:40.099Z'),
        },
        {
          name: 'Aaron',
          assets: 40000.56,
          invitedAt: moment('1999-08-11T21:06:40.099Z'),
        },
        {
          name: 'Abel',
          assets: 45045,
          joinedAt: moment('1998-08-12T21:06:40.099Z'),
        },
        {
          name: 'Sloane',
          assets: 234789.890,
          invitedAt: moment('2016-12-11T21:06:40.099Z'),
        },
        {
          name: 'Ivan',
          assets: 564000,
          joinedAt: moment('2016-10-12T21:06:40.099Z'),
        },
        {
          name: 'Oprah',
          assets: 4190,
          joinedAt: moment('2010-04-12T21:06:40.099Z'),
        },
        {
          name: 'Riley',
          assets: 10123.97,
          joinedAt: moment('1998-01-23T21:06:40.099Z'),
        },
        {
          name: 'Lauren',
          assets: 409,
          joinedAt: moment('2012-08-11T21:06:40.099Z'),
        },
      ],
    };
  },
  computed: {
    isSortedByInvitedAt() {
      return this.selectedSortOption === 'invitedAt';
    },
  },
  methods: {
    optionSelected(order) {
      this.selectedSortOption = order.sortBy;
    },
    close(order) {
      this.selection = order;
    },
  },
};

</script>

<style lang="scss" scoped>


  .client-list-example {
    width: 100%;
  }

  h1 {
    margin-left: 0.5rem;

    @media #{$screen-width-medium} {
      margin-left: 1rem;
    }
  }

  #mobile-action-menu {
    text-align: center;
    span { margin-left: 0.25rem; }
    @media #{$screen-width-small} {
      display: none;
    }
  }

  .header-labels {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem;

    @media #{$screen-width-medium} {
      padding: 0.5rem 1rem;
    }
  }

  .header-labels > span {
    color: $pearl-500;
  }

</style>
